/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ start: NonNullable<unknown>, end: NonNullable<unknown> }} Dashboard_PeriodInputs */

const cs_dashboard_period = /** @type {(inputs: Dashboard_PeriodInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Období ${i?.start} – ${i?.end}`)
};

const en_dashboard_period = /** @type {(inputs: Dashboard_PeriodInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Period ${i?.start} – ${i?.end}`)
};

/**
* | output |
* | --- |
* | "Period {start} – {end}" |
*
* @param {Dashboard_PeriodInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const dashboard_period = /** @type {((inputs: Dashboard_PeriodInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashboard_PeriodInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dashboard_period(inputs)
	return cs_dashboard_period(inputs)
});